import { render, staticRenderFns } from "./WhiteLabelDemo.vue?vue&type=template&id=7a91fe5e&scoped=true"
import script from "./WhiteLabelDemo.vue?vue&type=script&lang=js"
export * from "./WhiteLabelDemo.vue?vue&type=script&lang=js"
import style0 from "./WhiteLabelDemo.vue?vue&type=style&index=0&id=7a91fe5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a91fe5e",
  null
  
)

export default component.exports